import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { GetImageUrl } from "../helpers/GetImageUrl";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

const normalizeSlides = (banners = []) =>
  banners.flatMap((banner) => {
    const artworks = Array.isArray(banner.artworks) && banner.artworks.length
      ? banner.artworks
      : banner.image
        ? [{ image: banner.image, imagePublicId: banner.imagePublicId, altText: banner.altText, order: banner.order, isActive: true }]
        : (banner.images || []).map((image, index) => ({ image, altText: banner.altText, order: index + 1, isActive: true }));

    return artworks
      .filter((artwork) => artwork?.image && artwork.isActive !== false)
      .sort((first, second) => (Number(first.order) || 0) - (Number(second.order) || 0))
      .map((artwork, index) => ({
        ...artwork,
        _slideKey: `${banner._id || "banner"}-${artwork._id || artwork.imagePublicId || index}`,
        image: artwork.image,
        altText: artwork.altText || banner.altText || banner.title || "Suraksha 24X7 Banner",
      }));
  });

export default function DynamicBanner({ banners = [], loading = false }) {
  const slides = normalizeSlides(banners);
  const canSlide = slides.length > 1;

  if (loading) {
    return <div className="h-[200px] bg-black animate-pulse md:h-[500px]" />;
  }

  if (!slides.length) return null;

  return (
    <section className="relative overflow-hidden bg-black aspect-[1900/568]">
      <style>{`
.swiper-pagination-bullet{
 background:white!important;
 opacity:.5;
 width:8px;
 height:8px;
 transition:.3s;
}

.swiper-pagination-bullet-active{
 background:#f59e0b!important;
 width:30px;
 border-radius:20px;
}

@keyframes zoomBanner{
0%{ transform:scale(1); }
100%{ transform:scale(1.08); }
}
`}</style>

      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        effect="fade"
        speed={1200}
        autoplay={
          canSlide
            ? {
                delay: 5000,
                disableOnInteraction: false,
              }
            : false
        }
        pagination={canSlide ? { clickable: true } : false}
        loop={canSlide}
        grabCursor={true}
        watchSlidesProgress={true}
        className="h-full"
      >
        {slides.map((item) => {
          const imageUrl = GetImageUrl(item.image);

          return (
            <SwiperSlide key={item._slideKey}>
              <img
                src={imageUrl}
                alt={item.altText}
                loading="eager"
                decoding="async"
                className="h-full w-full object-cover object-center"
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}
